import { Component, OnInit } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Draw, Modify, Snap } from 'ol/interaction';
import GeoJSON from 'ol/format/GeoJSON';
import { fromLonLat } from 'ol/proj';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import WFS from 'ol/format/WFS';

import { Geometry } from 'ol/geom';
import Feature from 'ol/Feature';

@Component({
  selector: 'app-map-editor',
  templateUrl: './map-editor.component.html',
  styleUrls: ['./map-editor.component.css']
})
export class MapEditorComponent implements OnInit {
  map!: Map;
  vectorSource!: VectorSource;
  draw!: Draw;
  modify!: Modify;
  snap!: Snap;

  geoServerUrl = 'http://localhost:8080/geoserver/ows'; // WFS Service URL

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.initMap();
    this.loadGeoJSON();
  }

  initMap(): void {
    this.vectorSource = new VectorSource({
      format: new GeoJSON()
    });

    const vectorLayer = new VectorLayer({
      source: this.vectorSource
    });

    this.map = new Map({
      target: 'map',
      layers: [
        new TileLayer({
          source: new OSM()
        }),
        vectorLayer
      ],
      view: new View({
        center: fromLonLat([72.8777, 19.0760]), // Mumbai coordinates
        zoom: 12
      })
    });

    this.modify = new Modify({ source: this.vectorSource });
    this.map.addInteraction(this.modify);

    this.snap = new Snap({ source: this.vectorSource });
    this.map.addInteraction(this.snap);
  }

  loadGeoJSON(): void {
    const url = `${this.geoServerUrl}?service=WFS&version=1.1.0&request=GetFeature&typeName=ne:coastlines&outputFormat=application/json`;

    this.http.get(url).subscribe(
      (data: any) => {
        const features = new GeoJSON().readFeatures(data);
        this.vectorSource.addFeatures(features);
      },
      (error) => console.error('Error loading GeoJSON:', error)
    );
  }

  addDrawInteraction(type: 'Point' | 'LineString' | 'Polygon'): void {
    if (this.draw) this.map.removeInteraction(this.draw);

    this.draw = new Draw({
      source: this.vectorSource,
      type
    });
    this.map.addInteraction(this.draw);
  }

  exportGeoJSON(): void {
    const geojson = new GeoJSON().writeFeatures(this.vectorSource.getFeatures());
    console.log(geojson);
    alert('Exported GeoJSON:\n' + geojson);
  }

  saveGeoJSONrest(): void {
    const geojson = new GeoJSON().writeFeaturesObject(this.vectorSource.getFeatures());
    const headers = new HttpHeaders({
      'Content-Type': 'application/xml',
      'Accept': 'application/xml'
    });
    
    this.http.post('http://localhost:8080/geoserver/wfs', geojson, { headers })
      .subscribe(response => {
        console.log('Success:', response);
      }, error => {
        console.error('Error:', error);
      });
  }
  saveGeoJSON(): void {
    const features: Feature<Geometry>[] = this.vectorSource.getFeatures();

    if (features.length === 0) {
      console.error('No features to save!');
      return;
    }
    // / Swap Lat/Lon if necessary
    features.forEach(feature => {
      const geometry = feature.getGeometry();
      if (geometry) {
        geometry.applyTransform((coords:any, output:any, dim:any) => {
          for (let i = 0; i < coords.length; i += dim) {
            // Swap only for 2D coordinates (lon, lat → lat, lon)
            const temp = coords[i];
            coords[i] = coords[i + 1];
            coords[i + 1] = temp;
          }
          return output;
        });
      }
    });
    // Convert features to WFS-T XML format
    const formatWFS = new WFS();
    const transactionXML = formatWFS.writeTransaction(
      features,  // Insert features
      [],        // Update features (empty array instead of null)
      [],        // Delete features (empty array instead of null)
      {
        featureNS: 'http://www.yournamespace.com', // Replace with your namespace
        featurePrefix: 'ne', // Replace with your workspace
        featureType: 'boundary_lines_land', // Replace with your layer name
        srsName: 'EPSG:3857'
      } as any
    );

    // Convert XML Document to String
    const serializer = new XMLSerializer();
    const xmlString = serializer.serializeToString(transactionXML);

    // Headers
    const headers = new HttpHeaders({
      'Content-Type': 'application/xml',
      'Accept': 'application/xml'
    });

    // Send request
    this.http.post('http://localhost:8080/geoserver/wfs', xmlString, { headers })
      .subscribe(response => {
        console.log('Success:', response);
      }, error => {
        console.error('Error:', error);
      });
  }
}
